/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */
class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.mobileBreakpoint = '(max-width: 989px)';
    this.selectors = {
      slider: '[data-slider]',
      mediaItem: '[data-media-id]',
    };
    this.selectedMediaIndex =
      Number(
        this.querySelector(this.selectors.slider).querySelector(
          '[data-selected]',
        )?.dataset.index,
      ) || 0;
    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
      },
      instances: {
        slider: null,
      },
      options: {
        slider: {
          initialSlide: this.selectedMediaIndex,
          spaceBetween: 0,
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          },
        },
      },
    };
  }

  connectedCallback() {
    this.attachEvents();
  }

  attachEvents() {
    this.debouncedResize = debounce(() => {
      if (window.matchMedia(this.mobileBreakpoint).matches) {
        if (this.settings.instances.slider) return;
        this.init();
      } else {
        if (!this.settings.instances.slider) return;

        this.settings.instances.slider.destroy();

        this.settings.instances.slider = null;
      }
    }, 300);

    ['load', 'resize'].forEach((eventName) => {
      window.addEventListener(eventName, this.debouncedResize.bind(this));
    });
  }

  init() {
    if (!this.settings.elements.slider) return;

    this.settings.instances.slider = new Swiper(
      this.settings.elements.slider,
      this.settings.options.slider,
    );
  }

  setActiveMedia(id) {
    const mediaFound = Array.from(
      this.querySelectorAll(this.selectors.mediaItem),
    ).find((media) => Number(media.dataset.mediaId) === id);
    if (!mediaFound) return;
    if (!this.settings.instances.slider) return;
    this.settings.instances.slider.slideTo(Number(mediaFound.dataset.index));
  }
}

customElements.define('product-media', ProductMedia);
